import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRoutes } from "react-router-dom";
import routes from "@/routes";
import "@/styles/global/index.css";
import Header from "@/core/components/layout/Header/index";
import Footer from "@/core/components/layout/Footer";
const App = () => {
    const routing = useRoutes(routes);
    return (_jsxs("div", { className: "flex flex-col min-h-screen", children: [_jsx(Header, {}), _jsx("main", { className: "flex-grow bg-dark-gunmetal-100", children: routing }), _jsx(Footer, {})] }));
};
export default App;
